import * as yup from 'yup';

import { accountNumberReg } from '@/lib/regex/bank-account';
import { phoneNumberReg } from '@/lib/regex/personal-info';

export const simpleApplyFormSchema = yup
  .object({
    phone: yup
      .string()
      .length(phoneNumberReg.minLength, phoneNumberReg.requiredMessage)
      .matches(phoneNumberReg.regExp, phoneNumberReg.patternMessage)
      .required(phoneNumberReg.requiredMessage),
    bankId: yup.string().required(),
    accountNumber: yup.string().required(accountNumberReg.requiredMessage).matches(accountNumberReg.regExp, accountNumberReg.patternMessage),
    isAgreeTerm: yup.boolean().required().oneOf([true], '약관에 동의해야 합니다.')
  })
  .required();
